import React, { useState } from 'react';
import styles from '../../../CustomerDash/Components/allEnquiresTab/specificationsTab.module.css';
import { Download, Filter } from '../../../../Svg';
import { Menu, MenuItem, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import CatPagination from '../../../../Website/utils/Pagination';
import AllVenOrderTable from './AllVenOrderTable';

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '014px',
  color: '#667085',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  borderRadius: "4px",
  height: "40px",
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

const AllVenOrderTab = ({ attributes, additionalResources, setStatus, }) => {
  const [activeTab, setActiveTab] = useState('Cart order');
  const tabs = ['Cart order', 'PO Completed orders'];


  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (status) => {
    if (status) {
      setStatus(status)

    }
    setAnchorEl(null);
  };
  return (
    <>
      <div className={styles.profilebodyContainer}>
        <div className={styles.profileheader}>
          <h2>All Enquiry</h2>

          <div className={styles.displayFlex} >
            <div>
              <ActionButton
                onClick={handleClick}
                sx={{
                  color: '#667085',
                  border: '1px solid #E0E2E7',
                  background: '#fff',
                  borderRadius: '8px',
                }}
              >
                <Filter /> Filters
              </ActionButton>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'status-button',
                }}
              >
                <MenuItem onClick={() => handleClose('ACTIVE')}
                  sx={{
                    borderBottom: '1px solid #E6E1E5',
                    fontSize: '14px',
                    color: '#667085',
                  }}>Active</MenuItem>
                <MenuItem onClick={() => handleClose('INACTIVE')}
                  sx={{
                    fontSize: '14px',
                    color: '#667085',
                  }}>Inactive</MenuItem>
              </Menu>
            </div>
            <button className={styles.submitBtn}><Download /> Download</button>
          </div>
        </div>
        <div className={styles.speccontainer}>
          <div className={styles.spectabs}>
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`${styles.spectabButton} ${activeTab === tab ? styles.active : ''}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab === 'Cart order' && 'Cart order'}
                {tab === 'PO Completed orders' && 'PO Completed orders'}
              </button>
            ))}
          </div>

          {activeTab === 'Cart order' && (
            <AllVenOrderTable />
          )}

          {activeTab === 'PO Completed orders' && (
            <AllVenOrderTable />
          )}

        </div>
        <CatPagination />
      </div>
    </>
  );
};

export default AllVenOrderTab;
